module.exports = __webpack_public_path__ + "static/media/AvatarFaadi.aa0c2995.png";